export enum Team {
  ConnectionsWeb = 'ConnectionsWeb',
  ActivationWeb = 'ActivationWeb',
}
